/* Generated by ./script/iconify.js */
/* eslint-disable */
import React from 'react'
import PropTypes from 'prop-types'
import IconBase from './IconBase'
import classnames from 'classnames'

const IconBackarrow = ({ className, ...rest }) => {
  const classes = classnames(
    'icon',
    'icon--backarrow',
    className,
  )

  return (
    <IconBase className={classes} viewBox="0 0 24 16" fill="none" xmlns="http://www.w3.org/2000/svg"{...rest}><path className="path1" opacity=".5" fillRule="evenodd" clip-rule="evenodd" d="M23.25 6.75H5.538l4.474-4.487L8.25.5.75 8l7.5 7.5 1.762-1.762L5.537 9.25H23.25v-2.5z" fill="#9B9B9B"/></IconBase>
  )
}

IconBackarrow.propTypes = {
  className: PropTypes.string,
}

export default IconBackarrow
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/icons/IconBackarrow.js